import { combineReducers } from "redux";
import pedidos from "./pedidos";
import productos from "./productos";
import sistema from "./sistema";
import admin from "./admin";
import notificaciones from "./notificaciones";

export default combineReducers({ productos, pedidos, sistema, admin, notificaciones});